import React, { useEffect, useRef, useState } from "react";
import "../../assets/styles/components/avatar.scss";
import { useDispatch, useSelector } from "react-redux";
import { findValue, updateInput } from "../Input/functions";
import { Menu, MenuItem } from "@mui/material";
import { useAppSelector } from "store/store";

export default function ImagePicker(props: any) {
  const { input } = props;
  const dispatch = useDispatch();
  const store = useAppSelector((x: any) => x);
  const formData = store.formReducer;
  const editItem = store.formReducer.editItem;
  const activeIndex = store.formReducer.activeIndex;
  const defaultValue = input.defaultValue ?? null;

  const [selectedImage, setSelectedImage] = useState<string | null>();
  const [anchorEl, setAnchorEl] = useState<any>();
  const fileRef = useRef<any>(null);

  useEffect(() => {
    setSelectedImage(undefined);
    updateValue();
  }, []);

  useEffect(() => {
    updateValue();
  }, [activeIndex, editItem]);

  const updateValue = () => {
    let value = findValue(
      formData,
      input.formType,
      `${input.name}_url`,
      editItem ? editItem["avatar"] ?? editItem["imageUrl"] : defaultValue
    );
    if (value) {
      try {
        value = typeof value === "string" ? value : URL.createObjectURL(value);
        setSelectedImage(value);
        updateInput(dispatch, input.formType, `${input.name}_url`, value, input.primary);
      } catch (error) {}
    } else {
      setSelectedImage(null);
      updateInput(dispatch, input.formType, `${input.name}_url`, null, input.primary);
    }
  };

  const onChange = (e: any) => {
    const value = URL.createObjectURL(e.target.files[0]);
    updateInput(dispatch, input.formType, input.name, e.target.files[0], input.primary);
    updateInput(dispatch, input.formType, `${input.name}_url`, value, input.primary);
    updateInput(dispatch, input.formType, `deleteImage`, false, true);
    setSelectedImage(value);
  };

  const deleteImage = () => {
    updateInput(dispatch, input.formType, input.name, defaultValue, input.primary);
    updateInput(dispatch, input.formType, `${input.name}_url`, defaultValue, input.primary);
    updateInput(dispatch, input.formType, `deleteImage`, true, true);
    setSelectedImage(defaultValue);
  };

  return (
    <div className="warp-avatar">
      <div className="body-avatar">
        <img
          className="img-default"
          src={selectedImage ? selectedImage : input.defaultImage}
          alt="ImgDefault"
        />
        <img
          className={selectedImage ? "img-url-default-hover" : "img-default-hover"}
          src={
            selectedImage ? selectedImage : editItem && editItem.avatar ? editItem.avatar : input.defaultImage
          }
          alt="ImgDefaultHover"
        />
        <div className="add-img-avatar" onClick={(e) => setAnchorEl(e.currentTarget)}>
          <img src={input.addIcon} alt="plus" />
        </div>
        <Menu
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          dir="rtl"
          anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
          transformOrigin={{ horizontal: "center", vertical: "top" }}
          onClose={() => setAnchorEl(null)}
        >
          <MenuItem
            className="gap-2"
            onClick={() => {
              setAnchorEl(null);
              fileRef.current?.click();
            }}
          >
            <img src={props.input.editIcon} alt="IconEdit" />
            {props.input.editTitle}
          </MenuItem>
          <MenuItem
            onClick={() => {
              setAnchorEl(null);
              deleteImage();
            }}
            className="gap-2"
          >
            <img src={props.input.deleteIcon} alt="IconDelete" />
            {props.input.deleteTitle}
          </MenuItem>
        </Menu>
        <input className="input-type-file" type="file" onChange={(e) => onChange(e)} hidden ref={fileRef} />
      </div>
    </div>
  );
}
